import CommonService from '../../../../services/commonService';
import React from 'react';
import { connect } from 'react-redux';

const saopauloIcon1 = '/assets/saopaulo/about-us/BusesSaoPaulo-Website-TheCompany-Vision-Icon.svg';
const saopauloIcon2 = '/assets/saopaulo/about-us/BusesSaoPaulo-Website-TheCompany-Values-Icon.svg';

const santajuanaIcon1 = '/assets/santajuana/about-us/Nuestra-visión-icon.svg';
const santajuanaIcon2 = '/assets/santajuana/about-us/Nuestros-valores-icon.svg';

const navegadoresIcon1 = '/assets/losnavegadores/about/icon-one.svg';
const navegadoresIcon2 = '/assets/losnavegadores/about/icon-two.svg';

const chilebusIcon1 = '/assets/chilebus/company/flag.svg';
const chilebusIcon2 = '/assets/chilebus/company/heart.svg';

const getIconsAndTexts = operator => {
	const lightBg =
		operator && operator.color_codes && operator.color_codes.light_primary_color
			? operator.color_codes.light_primary_color
			: '#f7f7f7';
	const darkBg = operator && operator.operator_name === "losnavegadores" ? "#eaeaea" : operator && operator.color_codes && operator.color_codes.primary_color;

	const saopauloIconsAndTexts = [
		{
			image: saopauloIcon1,
			title: 'Nuestra visión',
			des:
				'Ofrecer la mejor y moderna opción de transporte de pasajeros en la región, asegurando un buen servicio, con puntualidad, seguridad, confort y cortesía, poniendo a disposición del público la flota más moderna de la región con buses de primera línea.',
			background: lightBg,
		},
		{
			image: saopauloIcon2,
			title: 'Nuestros valores',
			des:
				'La honestidad, humildad, responsabilidad y compromiso con nuestros clientes es lo que nos impulsa cada día a ser mejores para entregar un servicio de calidad por medio de un personal competente y comprometido con la organización.',
			background: darkBg,
		},
	];

	const navegadoresIconsAndTexts = [
		{
			image: navegadoresIcon1,
			title: 'Nuestra visión',
			des:
				`La visión de Buses  <strong> Los Navegadores</strong> es consolidarse como la empresa líder en el transporte de pasajeros en la Región de Los Lagos, reconocida por su compromiso con la calidad del servicio, la seguridad y la satisfacción del cliente. Aspiran a expandir sus rutas y servicios, contribuyendo al desarrollo y conectividad de las comunidades locales, mientras implementan tecnologías innovadoras y prácticas sostenibles que promuevan el cuidado del medio ambiente.`,
			background: lightBg,
		},
		{
			image: navegadoresIcon2,
			title: 'Nuestros valores',
			des: `
						<ul>
							<li>Calidad de servicio: Ofrecer una experiencia de viaje confortable y puntual, atendiendo las necesidades y expectativas de los usuarios.</li>
							<li>Compromiso con la comunidad: Contribuir al desarrollo local proporcionando servicios de transporte que faciliten la movilidad de los residentes y visitantes.</li>
							<li>Innovación: Incorporar tecnologías avanzadas que mejoren la eficiencia operativa y la satisfacción del cliente.</li>
							<li>Sostenibilidad: Implementar prácticas responsables con el medio ambiente, promoviendo un transporte más limpio y eficiente.</li>
						</ul>
		`,
			background: darkBg,
		},
	];
	const santajuanaIconsAndTexts = [
		{
			image: santajuanaIcon1,
			title: 'Nuestra visión',
			des:
				'Pretendemos ser artífices de la construcción y operación del nuevo y más moderno sistema de transporte público rural de la Región del BioBio, siendo pioneros en la implementación de tecnología de vanguardia en nuestros buses y nuestras operaciones.',
			background: lightBg,
		},
		{
			image: santajuanaIcon2,
			title: 'Nuestros valores',
			des: `- Compromiso            - Respeto\n
            - Seguridad             - Inclusión\n
            - Responsabilidad       - Trabajo en equipo`,
			background: darkBg,
		},
	];
	const chilebusIconsAndTexts = [
		{
			image: chilebusIcon1,
			title: 'Nuestra visión: ',
			des:
				'Ser líder en el mercado de transporte de pasajeros, carga y encomiendas, desarrollando recursos humanos y técnicos para brindar altos estándares de calidad y servicio diferenciado a nuestros clientes.',
			background: lightBg,
		},
		{
			image: chilebusIcon2,
			title: 'Nuestra misión: ',
			des: `Proveer soluciones de traslado de personas, carga y encomiendas en el norte de Chile. Satisfacer las necesidades de transporte de pasajeros y carga a personas y empresas, de manera rentable, confiable y eficiente, con la mejor utilización de nuestra infraestructura, flota, cobertura, equipo humano y tecnología.`,
			background: darkBg,
		},
	];
	const name = operator && operator.operator_name;
	if (name === 'saopaulo') {
		return saopauloIconsAndTexts;
	}
	if (name === 'santajuana') {
		return santajuanaIconsAndTexts;
	}
	if (name === 'chilebus') {
		return chilebusIconsAndTexts;
	}
	if (name === 'losnavegadores') {
		return navegadoresIconsAndTexts;
	} else {
		return [];
	}
};

const ThemeFourAboutIconSection = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	const renderIconsAndText = (item, key) => {
		return (
			<div
				className="icons-item"
				key={key}
				style={{
					background: item.background,
				}}
			>
				<div>
					<img src={item.image} alt="Giras de estudio" className="icon" />
				</div>
				<div
					className="title bold-text"
					style={{
						color: operator && operator.color_codes && operator.color_codes.primary_text_color,
					}}
				>
					<b>{item.title}</b>
				</div>



				{operator && operator.operator_name === "losnavegadores" ?
					(<div className="des losdec" dangerouslySetInnerHTML={{ __html: item.des }}></div>) : (<div className="des" dangerouslySetInnerHTML={{ __html: item.des }}></div>)
				}
			</div>


		);
	};

	return (
		<div className="themes-theme-four-about-icon-section new-container">
			{getIconsAndTexts(operator).map((item, key) => {
				return renderIconsAndText(item, key);
			})}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

export default connect(mapStateToProps, {})(ThemeFourAboutIconSection);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourAboutIconSection.js